// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wp_a bib_b bib_we"};